export const INTERVIEW_API_URL = '/api/interviews/';
export const INTERVIEWS_COUNT_API_URL = '/api/interviews/count/';
